import { apiGet, apiPut } from './client'
import type { ApiResponse, ObjectPermission, FieldPermission, DataScopeType } from '@crm/shared'

export interface ObjectPermissionRow {
  id: string
  tenant_id: string
  role_id: string
  object_id: string
  permission: ObjectPermission
  created_at: string
}

export interface FieldPermissionRow {
  id: string
  tenant_id: string
  role_id: string
  object_id: string
  field_id: string
  permission: FieldPermission
  created_at: string
}

export interface DataScopeRow {
  id: string
  tenant_id: string
  role_id: string
  object_id: string
  scope_type: DataScopeType
  custom_filter: string | null
  created_at: string
}

export async function fetchObjectPermissions(roleId: string): Promise<ApiResponse<ObjectPermissionRow[]>> {
  return apiGet<ApiResponse<ObjectPermissionRow[]>>(`/roles/${roleId}/object-permissions`)
}

export async function updateObjectPermissions(
  roleId: string,
  permissions: Array<{ object_id: string; permission: ObjectPermission }>,
): Promise<ApiResponse<{ success: boolean }>> {
  return apiPut<ApiResponse<{ success: boolean }>, { permissions: typeof permissions }>(
    `/roles/${roleId}/object-permissions`,
    { permissions },
  )
}

export async function fetchFieldPermissions(roleId: string): Promise<ApiResponse<FieldPermissionRow[]>> {
  return apiGet<ApiResponse<FieldPermissionRow[]>>(`/roles/${roleId}/field-permissions`)
}

export async function updateFieldPermissions(
  roleId: string,
  permissions: Array<{ object_id: string; field_id: string; permission: FieldPermission }>,
): Promise<ApiResponse<{ success: boolean }>> {
  return apiPut<ApiResponse<{ success: boolean }>, { permissions: typeof permissions }>(
    `/roles/${roleId}/field-permissions`,
    { permissions },
  )
}

export async function fetchDataScopes(roleId: string): Promise<ApiResponse<DataScopeRow[]>> {
  return apiGet<ApiResponse<DataScopeRow[]>>(`/roles/${roleId}/data-scopes`)
}

export async function updateDataScopes(
  roleId: string,
  scopes: Array<{ object_id: string; scope_type: DataScopeType; custom_filter?: string }>,
): Promise<ApiResponse<{ success: boolean }>> {
  return apiPut<ApiResponse<{ success: boolean }>, { scopes: typeof scopes }>(
    `/roles/${roleId}/data-scopes`,
    { scopes },
  )
}
